import { render } from "./No Data.vue?vue&type=template&id=d10ef1b0"
import script from "./No Data.vue?vue&type=script&lang=js"
export * from "./No Data.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__